import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-footer-phone',
  templateUrl: './icon-footer-phone.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFooterPhoneComponent {}
